import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendMessageLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5924 1.70406C13.7096 1.45825 14.7071 2.46605 14.4635 3.57971L14.4349 3.69104L11.5462 13.5739H11.5456C11.1741 14.8428 9.51855 15.1064 8.76429 14.0628L8.69397 13.9573L6.23432 9.95537L2.24797 7.48922C1.08933 6.77224 1.32269 5.01723 2.63079 4.63179L12.4805 1.7327L12.5924 1.70406ZM12.8437 2.67476L12.7624 2.69234L2.91334 5.59143C2.43665 5.73206 2.34884 6.37582 2.77402 6.63896L6.53576 8.96578L10.179 5.27242L10.2168 5.23791C10.412 5.07642 10.7017 5.08565 10.886 5.26721C11.0704 5.449 11.084 5.73898 10.9251 5.93648L10.8913 5.97424L7.23823 9.67802L9.54619 13.4339L9.59893 13.5075C9.8845 13.8461 10.454 13.7434 10.5859 13.2926L13.4753 3.41044L13.4935 3.32776C13.5492 2.9472 13.218 2.6199 12.8437 2.67476Z",
		fill: "currentColor"
	})
});
export default SvgSendMessageLine;
